import { ArrowRight } from "lucide-react";

export const CAPABILITY_STATEMENT_HREF = "#bottom-cta";

export function CommercialPrimaryCta({ label = "Request A Feasibility Assessment" }: { label?: string }) {
  return (
    <a
      href="#bottom-cta"
      className="inline-flex items-center justify-center gap-2 rounded-full bg-accent text-accent-foreground px-6 py-3.5 font-semibold shadow-cta hover:bg-accent/90 transition-colors w-full sm:w-auto"
    >
      {label}
      <ArrowRight className="h-4 w-4" aria-hidden />
    </a>
  );
}

// Capability statement / accreditation pack downloads have been removed
// site-wide. These exports are kept as no-op stubs so existing call sites
// compile without needing individual edits.
export function CommercialSecondaryCta(_props?: { label?: string; ghost?: boolean; href?: string }) {
  return null;
}

/** @deprecated Downloads removed; renders nothing. */
export const CommercialDownloadCta = CommercialSecondaryCta;

